import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"

import { optionalSession } from "@/app/optional-session"
import { AuthPanel } from "@/components/layout/auth-panel"

export const Route = createFileRoute("/_guest")({
  beforeLoad: async ({ context }) => {
    if (await optionalSession(context.queryClient)) {
      throw redirect({ to: "/" })
    }
  },
  component: GuestLayout,
})

function GuestLayout() {
  return (
    <AuthPanel brand={null}>
      <Outlet />
    </AuthPanel>
  )
}
